import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IRetailerSalesOrder,
  IRetailerSalesOrderInitialState,
} from "./retailerSalesOrderModel";
import {
  createRetailerSalesOrder,
  deleteRetailerSalesOrder,
  getAllRetailerMarginRates,
  getAllRetailerSalesOrders,
  getRetailerSalesOrderByID,
  updateRetailerSalesOrder,
} from "./services/retailerSalesOrder.services";

const initialState: IRetailerSalesOrderInitialState = {
  loading: false,
  error: "",
  RetailerSalesOrderID: null,
  RetailerSalesOrderList: [],
  MarginRateList: [],
  RetailerSalesOrderDetail: {
    retailerid: null,
    date: "",
    scheme: "",
    retailer_sales_order_list: [],
  },

  FilterRetailerSalesOrder: {
    retailer_name: "",
    date: "",
    distributor_name: "",
    area_name: "",
    order_taken_by_name: "",
  },
};

const retailerSalesOrderSlice = createSlice({
  name: "retailerSalesOrder",
  initialState,
  reducers: {
    clearRetailerSalesOrderDetails: (state) => {
      state.RetailerSalesOrderDetail = initialState.RetailerSalesOrderDetail;
    },
    setRetailerSalesOrderID: (state, action) => {
      state.RetailerSalesOrderID = action.payload;
    },
    clearRetailerSalesOrderID: (state) => {
      state.RetailerSalesOrderID = initialState.RetailerSalesOrderID;
    },
    clearMarginRateList: (state) => {
      state.MarginRateList = initialState.MarginRateList;
    },
    setFilterRetailerSalesOrder: (state, action) => {
      state.FilterRetailerSalesOrder = action.payload;
    },
    clearFilterRetailerSalesOrder: (state) => {
      state.FilterRetailerSalesOrder = initialState.FilterRetailerSalesOrder;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllRetailerSalesOrders.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllRetailerSalesOrders.fulfilled,
      (state, action: PayloadAction<IRetailerSalesOrder[]>) => {
        state.loading = false;
        state.RetailerSalesOrderList = action.payload || [];
      }
    );
    builder.addCase(getAllRetailerSalesOrders.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.RetailerSalesOrderList = [];
    });

    builder.addCase(createRetailerSalesOrder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createRetailerSalesOrder.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createRetailerSalesOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateRetailerSalesOrder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateRetailerSalesOrder.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateRetailerSalesOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteRetailerSalesOrder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteRetailerSalesOrder.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteRetailerSalesOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getRetailerSalesOrderByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getRetailerSalesOrderByID.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.RetailerSalesOrderDetail = action.payload;
      }
    );
    builder.addCase(getRetailerSalesOrderByID.rejected, (state, action) => {
      state.loading = false;
      state.RetailerSalesOrderDetail = initialState.RetailerSalesOrderDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllRetailerMarginRates.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllRetailerMarginRates.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.MarginRateList = action.payload || [];
      }
    );
    builder.addCase(getAllRetailerMarginRates.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.MarginRateList = [];
    });
  },
});

export const {
  clearRetailerSalesOrderDetails,
  clearRetailerSalesOrderID,
  setRetailerSalesOrderID,
  clearMarginRateList,
  setFilterRetailerSalesOrder,
  clearFilterRetailerSalesOrder,
} = retailerSalesOrderSlice.actions;
export default retailerSalesOrderSlice.reducer;
